import { Check, Clock, PlayCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { WorkflowStep } from "@/types/workflow";

export interface WorkflowStepStatusProps {
  status: WorkflowStep["status"];
  updating: boolean;
  onStatusUpdate: (newStatus: WorkflowStep["status"]) => Promise<void>;
}

export function WorkflowStepStatus({ status, updating, onStatusUpdate }: WorkflowStepStatusProps) {
  const getStatusIcon = (status: string) => {
    switch (status) {
      case "completed":
        return <Check className="h-4 w-4" />;
      case "in_progress":
        return <PlayCircle className="h-4 w-4" />;
      default:
        return <Clock className="h-4 w-4" />;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "bg-green-500/10 text-green-500 hover:bg-green-500/20";
      case "in_progress":
        return "bg-blue-500/10 text-blue-500 hover:bg-blue-500/20";
      default:
        return "bg-gray-500/10 text-gray-500 hover:bg-gray-500/20";
    }
  };

  return (
    <Badge
      variant="outline"
      className={`flex items-center gap-1 cursor-pointer transition-colors ${getStatusColor(status)}`}
      onClick={async () => {
        if (!updating) {
          try {
            let newStatus: WorkflowStep["status"];
            switch (status) {
              case "pending":
                newStatus = "in_progress";
                break;
              case "in_progress":
                newStatus = "completed";
                break;
              case "completed":
                newStatus = "pending";
                break;
              default:
                newStatus = "pending";
            }
            await onStatusUpdate(newStatus);
          } catch (error) {
            console.error("Error updating status:", error);
          }
        }
      }}
    >
      {getStatusIcon(status)}
      <span className="capitalize">
        {status.replace("_", " ")}
      </span>
    </Badge>
  );
}